<template>
  <div>
    <div class="ValidatorBetail">
      <div class="ValidatorBetail-W">
        <div class="Homeinput"><Homseach></Homseach></div>
        <div class="Transction"><Transction></Transction></div>
      </div>
    </div>
  </div>
</template>

<script>
import Homeinput from "../Home/Home_input";
import Homseach from "../../../components/pc/serch.vue";
import Transction from "../BkHash/Accounts";
export default {
  data() {
    return {};
  },
  components: {
    Homeinput,
    Transction,
    Homseach
  },
  mounted() {},

  methods: {
    
  },
};
</script>

<style lang="less" scoped>
.ValidatorBetail {
  width: 100%;
  background: #13161b;
  .ValidatorBetail-W {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 20px;
    .Homeinput {
      padding: 40px 0;
    }
  }
}
</style>
